<template>
    <div>
        <TopBar></TopBar>
        <SideMenu></SideMenu>
        <div class="container mx-auto page">
            <div class="pt-5">
                <ImageSlider></ImageSlider>
                <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                    <div v-for="(v) in 20" :key="v">
                        <div class="border-2 border-taro-yellow-1 rounded-xl overflow-hidden">
                            <img src="https://devstoragebuzzebees.blob.core.windows.net/campaigns/104703_283140-large?time=0">
                            <div class="p-3">
                                <div class="text-yellow-600 font-main-bold">ทาโร ปลาเส้น รสบาร์บีคิว 64 กรัม</div>
                                <div class="text-gray-400 font-main-light">ราคา 50 บาท</div>
                                <div class="mt-2">
                                    <button
                                        class="bg-taro-yellow-1 hover:bg-red-600 w-full text-white font-bold py-1 rounded-lg"
                                        @click="clickDetail()">
                                        Add to cart
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import SideMenu from "@/components/Layout/SideMenu/SideMenu.vue";
import ImageSlider from "../comnponent/ImageSlider.vue";
// import OwlSlider from "@/components/Slider/OwlSlider.vue";

export default {
    name: "TailwindMain",
    components: {
        TopBar,
        ImageSlider,
        SideMenu,
    },
    methods: {
        clickDetail: function() {
            this.$router.push("/tailwind/detail");
        },
    },
};
</script>
<style lang="scss" scoped>

</style>
